export class Interface {
    static isEmpty = (int: object) : boolean => { 
        return Object.keys(int).length === 0 
    }

    static emptyInterface = function<T>()
    {
        return ({} as any) as T;
    }
}
